<template>
  <h1 v-if="title">
    {{ title }} {{ currentIndex + 1 }}/{{ components.length }}
  </h1>
  <div class="carousel">
    <button class="arrow left" @click="prevSlide"><SvgLeftIcon /></button>

    <transition name="slide" mode="out-in">
      <div class="carousel-item" :key="currentIndex">
        <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner">
            <component :is="currentComponent" />
          </div>
        </div>
      </div>
    </transition>

    <button class="arrow right" @click="nextSlide"><SvgRightIcon /></button>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    title: {
      type: String,
      default: null,
    },
    components: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    currentComponent() {
      return this.components[this.currentIndex];
    },
  },
  methods: {
    nextSlide() {
      if (this.components.length === 0) return;
      this.currentIndex = (this.currentIndex + 1) % this.components.length;
    },
    prevSlide() {
      if (this.components.length === 0) return;
      this.currentIndex =
        (this.currentIndex - 1 + this.components.length) %
        this.components.length;
    },
  },
};
</script>

<style scoped lang="scss">
h1 {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 50px;
}

.carousel {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-item {
  width: 100%;
}

/* Transition animations */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
.slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

/* Arrows */
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 2rem;
  cursor: pointer;
  z-index: 2;
  user-select: none;
  border-radius: 100px;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: white;
  transition: background-color 0.2s ease;
}

.arrow.left {
  left: 10px;
}

.arrow.right {
  right: 10px;
}

.arrow:hover {
  background-color: rgba(255, 255, 255, 0.25);
}
</style>
